/**
 * Single source of truth for the legal identity of the business
 * operating giztoo.com.
 *
 * Used by the footer, About, Contact, Terms, Trust and the
 * Business information page, plus the Organization JSON-LD.
 * Google Merchant Center requires these details to be consistent
 * everywhere they appear.
 */
export const COMPANY = {
  legalName: 'Michal Moravcik',
  tradingName: 'GizToo',
  registrationId: '00940151',
  vatId: 'CZ8704244857',
  street: 'Vrchlickeho 2693/28',
  city: 'Kromeriz',
  postalCode: '767 01',
  country: 'Czechia',
  countryCode: 'CZ',
  email: 'info@giztoo.com',
  responseTime: 'within 24 hours',
  currency: 'USD',
} as const;

export const COMPANY_ADDRESS_LINE = `${COMPANY.street}, ${COMPANY.city}, ${COMPANY.country}`;

export const COMPANY_LEGAL_LINE = `Operated by ${COMPANY.legalName} · Reg. No. ${COMPANY.registrationId} · VAT ${COMPANY.vatId} · ${COMPANY_ADDRESS_LINE}`;

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'OnlineStore',
  name: COMPANY.tradingName,
  legalName: COMPANY.legalName,
  url: 'https://giztoo.com',
  email: COMPANY.email,
  taxID: COMPANY.registrationId,
  vatID: COMPANY.vatId,
  currenciesAccepted: COMPANY.currency,
  address: {
    '@type': 'PostalAddress',
    streetAddress: COMPANY.street,
    addressLocality: COMPANY.city,
    postalCode: COMPANY.postalCode,
    addressCountry: COMPANY.countryCode,
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: COMPANY.email,
    availableLanguage: ['English'],
    areaServed: ['US', 'CA', 'CZ', 'GB', 'EU'],
  },
} as const;
